module.exports = __webpack_public_path__ + "img/diamondsAsSaving@2x.cd1a1c4.jpg";